import React, { useEffect, useState } from "react";
import "./dev.css";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import {
  Btn,
  FormInput,
  FormTextArea,
  SelectInput2,
  SuccessComp,
  validateRequiredFields,
} from "../../utils/utils";
import { Add, Trash } from "iconsax-react";
import ReusableUpload from "../../utils/ReusableUpload";
import useEstates from "../../hooks/useEstates";
import { AxiosAuthPost, AxiosAuthPut } from "../../api/api";
import { useNavigate } from "react-router-dom";
import DocUpload from "../../utils/DocUpload";

const DevAddProp = () => {
  const editPropData = JSON.parse(localStorage.getItem("editProp"));
  // console.log(editPropData);

  const navigate = useNavigate();
  const url = "developer/properties/";
  const editUrl = `developer/properties/${editPropData?.id}/`;
  const [amenities, setAmenities] = useState(editPropData?.amenities || []);
  const { estatesArr } = useEstates();
  const [blocks, setBlocks] = useState(editPropData?.blocks || []);
  const [propType, setPropType] = useState(
    editPropData?.propertyType || "",
  );
  const [propUse, setPropUse] = useState(
    editPropData?.propertyUse || "",
  );
  const [successMsg, setSuccessMsg] = useState("");
  const [estType, setEstType] = useState(editPropData?.estate?.id || "");
  const [images, setImages] = useState([]);
  const [propDocs, setPropDocs] = useState(
    editPropData?.document
      ? editPropData.document.map((item) => item.link)
      : [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    propertyName: editPropData?.name,
    address: editPropData?.address,
    sizePerPlot: 0,
    numberOfPlots: 1,
    amenities: "",
    documentName: "",
    document: "",
    propertyType: editPropData?.propertyType,
    propertyType: editPropData?.propertyUse,
    propertyDescription: editPropData?.propertyDescription,
    blockName: "",
    numberOfUnits: editPropData?.numberOfUnits,
    pricePerUnit: 1,
    pictures: editPropData?.pictures
      ? editPropData.pictures.map((item) => item.link)
      : [],
    pricePerPlots: 1,
    estateId: editPropData?.estate?.id,
  });
  const [dataErr, setDataErr] = useState({
    propertyName: "",
    address: "",
    sizePerPlot: "",
    pricePerPlots: "",
    numberOfPlots: "",
    amenities: "",
    documentName: "",
    document: "",
    propertyType: "",
    propertyUse: "",
    propertyDescription: "",
    blockName: "",
    numberOfUnits: "",
    pricePerUnit: "",
    pictures: "",
  });
  const optionsType = [
    { value: "Building", id: "Building", name: "Building" },
    { value: "Land", id: "Land", name: "Land" },
  ];
  const propUseType = [
    { value: "Residential", id: "Residential", name: "Residential" },
    { value: "Commercial", id: "Commercial", name: "Commercial" },
  ];
  const estateType = estatesArr;

  const handlePropChange = (value) => {
    setPropType(value);
  };
  const handlePropUseChange = (value) => {
    setPropUse(value);
  };
  const handleEstChange = (value) => {
    setEstType(value);
  };
  const addAmen = () => {
    if (data.amenities !== "") {
      setAmenities((prev) => {
        return [...prev, data.amenities];
      });
      setData((prev) => ({
        ...prev,
        amenities: "",
      }));
    } else {
      setDataErr((prev) => ({
        ...prev,
        amenities: "Field cannnot be empty",
      }));
    }
  };

  const rmAmen = (indexToRemove) => {
    setAmenities((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const blkData = {
    blockName: data.blockName,
    numberOfPlots: data.numberOfPlots,
    sizePerPlot: data.sizePerPlot,
    pricePerPlot: data.pricePerPlots,
  };
  const reqBlkData = {
    blockName: true,
    numberOfPlots: true,
    sizePerPlot: true,
    pricePerPlot: true,
  };

  const isValid = validateRequiredFields(blkData, reqBlkData);

  const addBlocks = () => {
    if (isValid) {
      setBlocks((prev) => [
        ...prev,
        {
          blockName: data.blockName,
          numberOfPlots: data.numberOfPlots,
          sizePerPlot: data.sizePerPlot,
          pricePerPlot: data.pricePerPlots,
        },
      ]);
      setData((prev) => ({
        ...prev,
        blockName: "",
        numberOfPlots: "",
        sizePerPlot: "",
        pricePerPlots: "",
      }));
    } else {
      setDataErr((prev) => ({
        ...prev,
        blockName: !data.blockName && "Field cannnot be empty",
        numberOfPlots: !data.numberOfPlots && "Field cannnot be empty",
        sizePerPlot: !data.sizePerPlot && "Field cannnot be empty",
        pricePerPlots: !data.pricePerPlots && "Field cannnot be empty",
      }));
    }
  };

  const rmBlks = (indexToRemove) => {
    setBlocks((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const dataSet = {
    propertyType: propType,
    propertyUse: propUse,
    estateId: estType,
    propertyName: data.propertyName,
    propertyDescription: data.propertyDescription,
    address: data.address,
    pictures: data.pictures,
    documents: propDocs,
    numberOfUnits: data.numberOfUnits,
    pricePerUnit: data.pricePerUnit,
    amenities: amenities,
    blocks: blocks,
  };
  

  useEffect(() => {
    if (propType === "Building") {
      setBlocks([]);
    }
    if (propType === "Land") {
      setAmenities([]);
    }
    // eslint-disable-next-line
  }, [propType]);

  // console.log(dataSet );

  const submit = () => {
    setIsLoading(true);
    // console.log(dataSet);
    
    AxiosAuthPost(url, dataSet)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res?.message);
        setTimeout(() => {
          navigate("/dev_dash/property");
          setSuccessMsg("");
        }, 2000);
        setData({
          propertyName: "",
          address: "",
          sizePerPlot: "",
          numberOfPlots: 0,
          amenities: "",
          propertyType: "",
          propertyDescription: "",
          blockName: "",
          documentName: "",
          document: "",
          numberOfUnits: 0,
          pricePerUnit: 0,
          pictures: [],
          pricePerPlots: 0,
        });
        setAmenities([]);
        setBlocks([]);
        setImages([]);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };
  // console.log(dataSet);

  const submitEditProp = () => {
    setIsLoading(true);
    AxiosAuthPut(editUrl, dataSet)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res?.message);
        setTimeout(() => {
          navigate("/dev_dash/property");
          setSuccessMsg("");
        }, 2000);
        setData({
          propertyName: "",
          address: "",
          sizePerPlot: "",
          numberOfPlots: 0,
          amenities: "",
          propertyType: "",
          propertyDescription: "",
          blockName: "",
          documentName: "",
          document: "",
          numberOfUnits: 0,
          pricePerUnit: 0,
          pictures: [],
          pricePerPlots: 0,
        });
        setAmenities([]);
        setBlocks([]);
        setImages([]);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  // console.log(dataSet);

  return (
    <div>
      <SuccessComp message={successMsg} />
      <AgentHeader header={editPropData ? "Edit Property" : "Add Property"} />
      <div className="estates_houses" style={{ marginTop: 0 }}>
        <div className="add_prop_inp">
          <div className="add_inp_sel">
            <SelectInput2
              options={optionsType}
              onChange={handlePropChange}
              label={"Property Type"}
              err={dataErr.propertyType}
            />
            <SelectInput2
              options={estateType}
              onChange={handleEstChange}
              label={"Estate"}
              err={dataErr.estateId}
            />
            <SelectInput2
              options={propUseType}
              onChange={handlePropUseChange}
              label={"Property Use"}
              err={dataErr.propertyUse}
            />
          </div>
          <FormInput
            label={"Property Name"}
            id={"propertyName"}
            changeInput={dataChange}
            value={data.propertyName}
            err={dataErr.propertyName}
          />
          <FormInput
            label={"Address"}
            id={"address"}
            changeInput={dataChange}
            value={data.address}
            err={dataErr.address}
          />
          <FormTextArea
            label={"Property Description"}
            id={"propertyDescription"}
            changeInput={dataChange}
            value={data.propertyDescription}
            err={dataErr.propertyDescription}
          />
        </div>
        <div className="add_prop_inp">
          {propType === "Building" && (
            <>
              <h3>Building details</h3>
              {/* <FormInput
                  label={"Document Name"}
                  id={"documentName"}
                  changeInput={dataChange}
                  value={data.documentName}
                  err={dataErr.documentName}
                /> */}
              <div className="amen_inp">
                <FormInput
                  label={"Price per Unit(#)"}
                  id={"pricePerUnit"}
                  changeInput={dataChange}
                  value={data.pricePerUnit}
                  err={dataErr.pricePerUnit}
                  type={"number"}
                />
              </div>
              <FormInput
                label={"Number of Units"}
                id={"numberOfUnits"}
                changeInput={dataChange}
                value={data.numberOfUnits}
                err={dataErr.numberOfUnits}
                type={"number"}
              />
              {amenities.map((item, idx) => {
                return (
                  item && (
                    <div key={idx} className="filled_blks">
                      <p>{item}</p>
                      <Trash
                        color="#444444"
                        size={24}
                        onClick={() => rmAmen(idx)}
                        cursor={"pointer"}
                      />
                    </div>
                  )
                );
              })}
              <div className="amenities_inp">
                <div className="amen_in">
                  <FormInput
                    label={"Amenities"}
                    id={"amenities"}
                    changeInput={dataChange}
                    value={data.amenities}
                    err={dataErr.amenities}
                  />
                </div>
                {/* <div className="amen_icon" onClick={rmAmen}>
                  <Trash color="#ff0000" size={24} />
                </div> */}
                <div className="amen_icon" onClick={addAmen}>
                  <Add size={24} color="#000000" />
                </div>
              </div>
            </>
          )}
          {propType === "Land" && (
            <>
              <div className="land_head">
                <div className="l_head_left">
                  <h3>Land Blocks</h3>
                </div>
              </div>
              {blocks.length !== 0 &&
                blocks.map((item, idx) => {
                  return (
                    <div key={idx} className="filled_blks">
                      <p>{item.blockName}</p>
                      <Trash
                        color="#444444"
                        size={24}
                        onClick={() => rmBlks(idx)}
                        cursor={"pointer"}
                      />
                    </div>
                  );
                })}
              <div className="l_blks">
                <FormInput
                  label={"Block Name"}
                  id={"blockName"}
                  changeInput={dataChange}
                  value={data.blockName}
                  err={dataErr.blockName}
                />
                <div className="blk_inp">
                  <FormInput
                    label={"Number of Plots"}
                    id={"numberOfPlots"}
                    changeInput={dataChange}
                    value={data.numberOfPlots}
                    err={dataErr.numberOfPlots}
                    type={"number"}
                  />
                  <FormInput
                    label={"Size per plot(sqm)"}
                    id={"sizePerPlot"}
                    changeInput={dataChange}
                    value={data.sizePerPlot}
                    err={dataErr.sizePerPlot}
                    type={"number"}
                  />
                  <FormInput
                    label={"Price per Plots(#)"}
                    changeInput={dataChange}
                    id={"pricePerPlots"}
                    value={data.pricePerPlots}
                    err={dataErr.pricePerPlots}
                    type={"number"}
                  />
                </div>
              </div>
              <div className="l_head_right">
                {/* <Btn
                    btnText={"Remove Block"}
                    btnClass={"btn_dark_out"}
                    btnClick={rmBlks}
                    leftIcon={<Trash color="#444444" size={24} />}
                  /> */}
                <Btn
                  btnText={"Add Block"}
                  btnClass={"btn_dark"}
                  btnClick={addBlocks}
                  leftIcon={<Add color="#FFFFFF" size={24} />}
                />
              </div>
            </>
          )}
          <div className="pic_us">
            <h4>Upload Documents</h4>
            <DocUpload
              docs={propDocs}
              setData={setData}
              setDocs={setPropDocs}
              dataErr={dataErr}
              data={data}
            />
          </div>
          <div className="pic_us">
            <h4>Pictures</h4>
            <ReusableUpload
              images={images}
              setData={setData}
              setImages={setImages}
              dataErr={dataErr}
              data={data}
            />
          </div>
        </div>
        <div className="est_btn">
          <Btn
            btnText={"Cancel"}
            btnClass={"home-btn_trans-s"}
            btnClick={() => {
              navigate(-1);
              localStorage.removeItem("editProp");
            }}
          />
          <Btn
            btnText={"Save Property"}
            btnClass={"home-btn_s"}
            btnClick={editPropData ? submitEditProp : submit}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default DevAddProp;
